import Link from 'next/link';
import styles from '../../styles/components/sections/AuthorSection.module.css';
import { OptimizedImage } from '../common';

const AuthorSection = ({ author }) => {
    if (!author) return null;

    return (
        <div className={styles.authorSection}>
            
            <div className={styles.authorInfo}>
                <div className={styles.authorImage}>
                    {author.image?.url ? (
                        <OptimizedImage
                            src={author.image.url}
                            alt={author.name}
                            width={70}
                            height={70}
                            className={styles.authorImg}
                            priority={false}
                            loading="lazy"
                            quality={65}
                            sizes="70px"
                        />
                    ) : (
                        <div className={styles.authorPlaceholder}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                <circle cx="12" cy="7" r="4"/>
                            </svg>
                        </div>
                    )}
                </div>
                <div className={styles.authorDetails}>
                    <div>
                        <span className={styles.authorTitle}>WRITTEN BY</span>
                    </div>
                    <Link href={`/author/${author.slug}`} className={styles.authorNameLink}>
                        <h3 className={styles.authorName}>{author.name}</h3>
                    </Link>
                    {author.description && (
                        <p className={styles.authorBio}>{author.description}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuthorSection;
